import { CONFIG } from './config.js';

const STORAGE_KEY = 'mlb_stadium_simulator_state';

class StateManager {
  constructor() {
    this.subscribers = [];
    this.state = this._loadInitialState();
  }

  _loadInitialState() {
    const defaults = CONFIG.defaults;
    if (import.meta.env.PROD) {
      return {
        lat: defaults.lat,
        lng: defaults.lng,
        alt: defaults.alt,
        rotation: defaults.rotation,
        scale: defaults.scale,
        date: defaults.date,
        time: defaults.time,
        mapsEnabled: false,
        baseScale: defaults.baseScale || 1.174947733769433,
        stadiumName: 'Stadium_KC.glb'
      };
    }

    try {
      const cached = localStorage.getItem(STORAGE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        return {
          lat: typeof parsed.lat === 'number' ? parsed.lat : defaults.lat,
          lng: typeof parsed.lng === 'number' ? parsed.lng : defaults.lng,
          alt: typeof parsed.alt === 'number' ? parsed.alt : defaults.alt,
          rotation: typeof parsed.rotation === 'number' ? parsed.rotation : defaults.rotation,
          scale: typeof parsed.scale === 'number' ? parsed.scale : defaults.scale,
          date: defaults.date, // Always start with current date
          time: defaults.time, // Always start with current time
          mapsEnabled: defaults.mapsEnabled, // Always start with basic 3D view
          baseScale: typeof parsed.baseScale === 'number' ? parsed.baseScale : (defaults.baseScale || 1.0),
          stadiumName: 'Stadium_KC.glb' // Always default to KC stadium on startup
        };
      }
    } catch (e) {
      console.warn('Failed to load state from localStorage, using defaults.', e);
    }
    return {
      ...defaults,
      baseScale: defaults.baseScale || 1.0,
      stadiumName: 'Stadium_KC.glb' // Always default to KC stadium on startup
    };
  }

  getState() {
    return { ...this.state };
  }

  updateState(updates) {
    const oldState = { ...this.state };
    this.state = { ...this.state, ...updates };

    // Persist to local storage (excluding dynamic variables like baseScale and stadiumName)
    try {
      const persistData = {
        lat: this.state.lat,
        lng: this.state.lng,
        alt: this.state.alt,
        rotation: this.state.rotation,
        scale: this.state.scale,
        date: this.state.date,
        time: this.state.time,
        mapsEnabled: this.state.mapsEnabled,
        baseScale: this.state.baseScale
        // stadiumName is deliberately not persisted to ensure KC loads by default
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(persistData));
    } catch (e) {
      console.warn('Failed to save state to localStorage', e);
    }

    this._notify(this.state, oldState);
  }

  resetToDefaults() {
    this.updateState({
      ...CONFIG.defaults
    });
  }

  subscribe(callback) {
    this.subscribers.push(callback);
    // Call immediately to sync current state
    callback(this.state, this.state);
    return () => {
      this.subscribers = this.subscribers.filter(sub => sub !== callback);
    };
  }

  _notify(newState, oldState) {
    this.subscribers.forEach(callback => callback(newState, oldState));
  }
}

export const AppState = new StateManager();
